// components
import ContentLayout from "@/layouts/ContentLayout";
import TextBlock from "@/components/blocks/TextBlock";

// assets
import TitleBanner from "@/components/banners/TitleBanner";
import banner from "@/assets/images/the-circular-economy/banner.png";
import image1 from "@/assets/images/the-circular-economy/image1.png";
import circularProcess from "@/assets/images/the-circular-economy/circular-process.png";

// i18n
import { useTranslation } from "react-i18next";

const TheCircularEconomy = () => {
  const { t } = useTranslation();

  const data = [
    {
      title: "rethinking_waste_for_a_better_future",
      descriptions: [
        "rethinking_waste_for_a_better_future_description_1",
        "rethinking_waste_for_a_better_future_description_2",
        "rethinking_waste_for_a_better_future_description_3",
      ],
    },
    { title: "the_economic_advantage", descriptions: ["the_economic_advantage_description"] },
    { title: "the_circular_way_forward", descriptions: ["the_circular_way_forward_description"] },
  ];

  return (
    <div className="w-full">
      <TitleBanner bannerImg={banner} title={t("the_circular_economy.the_circular_economy")} />
      <ContentLayout>
        {/* <article className="flex w-full flex-col gap-6">
          {data.map((item, index) => (
            <TextBlock key={index} title={item.title} descriptions={item.descriptions} translationKey="the_circular_economy" />
          ))}
        </article> */}
        <article className="flex w-full flex-col gap-6">
          <TextBlock title={data[0].title} descriptions={data[0].descriptions} translationKey="the_circular_economy" />
        </article>

        <figure className="mt-9 w-full overflow-hidden rounded-lg flex justify-center items-center">
          <img src={circularProcess} alt="circular-process" className="h-full w-full" />
        </figure>

        <article className="mt-6 flex w-full flex-col gap-6">
          <TextBlock title={data[1].title} descriptions={data[1].descriptions} translationKey="the_circular_economy" />
        </article>
        <article className="mt-6 flex w-full flex-col gap-6">
          <TextBlock title={data[2].title} descriptions={data[2].descriptions} translationKey="the_circular_economy" />
        </article>
        <figure className="mt-9 h-fit w-full overflow-hidden rounded-lg">
          <img src={image1} alt="about-us-image1" className="w-full object-cover" />
        </figure>
      </ContentLayout>
    </div>
  );
};

export default TheCircularEconomy;
